import { jsx as _jsx } from "react/jsx-runtime";
//import React from 'react'
import { createRoot } from 'react-dom/client';
import { App } from './components/App';
import './index.scss';
import { Provider } from 'react-redux';
import { store } from './store/store';
import './firebase';
import './i18n';
const root = document.getElementById('root');
if (!root)
    throw new Error('root not found');
const container = createRoot(root);
container.render(_jsx(Provider, { store: store, children: _jsx(App, {}) }));
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker
            .register('/sw.js')
            .then(reg => console.log('[SW] Регистрация успешна:', reg.scope))
            .catch(err => console.log('[SW] Ошибка регистрации:', err));
    });
}
